import { render, staticRenderFns } from "./CourseInstitute.vue?vue&type=template&id=756f5308&scoped=true"
import script from "./CourseInstitute.vue?vue&type=script&lang=js"
export * from "./CourseInstitute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f5308",
  null
  
)

export default component.exports